import "./index.scss";

export const Card = ({ customClassName = "", children }) => {
  return (
    <div className={`card ${customClassName}`} id="card">
      {children}
    </div>
  );
};
